import { Subscription } from 'rxjs'

import { roomTiltLogic } from './roomTiltLogic'
import { createRoomMovement as RoomDefaults } from './roomHelpers'


// rxjs is a library capable of great things.
// Learning it is hard and i am sorry but i see no other perfect way but to use it here.
// https://css-tricks.com/animated-intro-rxjs/
type RotateValues = { rotX: number; rotY: number }

export type RoomMovement = {
  start: () => void
  stop: () => RotateValues
}
export const createRoomMovement = (element: HTMLElement): RoomMovement => {
  let mouseMove: Subscription
  let rotateValues: RotateValues = { rotX: 0, rotY: 0 }

  const start = () => {
    const { smoothMove$ } = roomTiltLogic()
    mouseMove = smoothMove$.subscribe((transform) => {
      element.style.transform = transform.roomMovement
      rotateValues = transform.rotateValues
    })
  }

  const stop = () => {
    mouseMove && mouseMove.unsubscribe()
    element.style.transform = RoomDefaults({})
    return rotateValues
  }

  return {
    start,
    stop,
  }
}
